import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';

import { RadioButtonGroup } from '@els/els-react--radio-button';

export default function GroupSubRadioButtons(props) {
  const { id: structureOptionsId, option, groupId, optionId, onSubRadioClick } = props;
  const subOptionsIds = option.get('subOptionsIds');

  if (!subOptionsIds || !option.get('checked')) {
    return null;
  }

  const subOptions = option.get('subOptions');

  return (
    <div className="group-radio-buttons-sub-options">
      {subOptionsIds.map((subOptionId) => {
        const subOption = subOptions.get(subOptionId);
        const id = subOption.get('id');
        const title = subOption.get('title');
        const checked = subOption.get('checked');

        return (
          <RadioButtonGroup.Option
            className="group-radio-buttons-radio"
            key={id}
            checked={checked}
            onChange={() => {
              onSubRadioClick(structureOptionsId, groupId, optionId, subOptionId);
            }}
            label={title}
          />
        );
      })}
    </div>
  );
}

GroupSubRadioButtons.propTypes = {
  id: PropTypes.string.isRequired,
  option: PropTypes.instanceOf(Map),
  groupId: PropTypes.string.isRequired,
  optionId: PropTypes.string.isRequired,
  onSubRadioClick: PropTypes.func.isRequired,
};
